export const config = {
  portfolio: {
    portfolioLogo: "Portfolio",
    projectCard: {
      cards: [
        {
          heading: "Ojiblogs",
          description:
            "A community-driven blogging platform built with Next.js and styled using Tailwind CSS. It enables users to share ideas, post articles, and engage with a dynamic audience.",
          animationDelay: "80",
          buttonLink: "https://the-oji-blogs.vercel.app/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "EasyMed",
          description:
            "An online doctor appointment platform ensuring seamless booking, browsing, and tracking. Built with React.js,Stripe/Razorpay,React-Taostify(For Notifications) Tailwind CSS, Node.js, Express.js, and MongoDB.",
          animationDelay: "130",
          buttonLink: "https://medoji.vercel.app/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Minesweeper Game",
          description:
            "An interactive Minesweeper game developed using Next.js, utilizing graph DFS (Depth-First Search) algorithms for efficient gameplay mechanics. Challenge yourself to uncover all tiles without hitting a mine.",
          animationDelay: "180",
          buttonLink: "https://mine-sweeper-game-vert.vercel.app/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Choganji",
          description:
            "A freelancing website showcasing Rajasthan's traditional hand block printing. Built with Next.js, Tailwind CSS, and integrated with e-commerce features.",
          animationDelay: "230",
          buttonLink: "https://www.choganji.com/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Ananya Logistics",
          description:
            "A freelancing website developed for a logistics company, featuring a fully responsive design using Bootstrap.",
          animationDelay: "280",
          buttonLink: "https://ananyalogistics.com/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Servoji",
          description:
            "A fullstack Home Service Web app using Next.js, Descope for authentication, Hygraph for database, and several other libraries.",
          animationDelay: "330",
          buttonLink: "https://home-service-web-app-fawn.vercel.app/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "OjiMedia",
          description:
            "A Mernstack project using MongoDB-Atlas for database, Express for backend framework, React for frontend, and Node.js. Cloudinary server is used for image upload. The password is authenticated with security.",
          animationDelay: "380",
          buttonLink: "https://ojimedia-byajaykumar.netlify.app/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "OjiSkills",
          description:
            "A full-fledged ALL-SKILL platform to learn skills in a planned and better way using Next.js as the framework, GraphQL for API querying, Tailwind CSS for styling, and Lucide React as a library for icons.",
          animationDelay: "430",
          buttonLink: "https://oji-skills.vercel.app/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "OjiMovies",
          description:
            "A movie browsing platform developed with React and Tailwind CSS, integrated with a movie database API. It allows users to explore movies, view details, and watch trailers through a seamless and user-friendly interface.",
          animationDelay: "480",
          buttonLink: "https://oji-movies.vercel.app/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Mine Game",
          description:
            "A thrilling stake mine game developed using HTML, CSS, and JavaScript. Dive into this strategic game to reveal safe spots while avoiding hidden mines and maximize your score.",
          animationDelay: "530",
          buttonLink: "https://akjajay9315.github.io/Mine-Game/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "OjiQR Generator",
          description:
            "A QR code generator built with HTML, CSS, and JavaScript, utilizing an API to create customizable QR codes quickly and efficiently for various uses.",
          animationDelay: "580",
          buttonLink: "https://akjajay9315.github.io/OjiQR-Generator/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "HooBank",
          description:
            "A payment site using Tailwind CSS for styling with React and Vite as frontend frameworks.",
          animationDelay: "630",
          buttonLink: "https://payment-site-akjajay.netlify.app/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Tindog",
          description:
            "A fully responsive app for dog lovers built with Bootstrap. The links are not functional right now but will be updated soon.",
          animationDelay: "680",
          buttonLink: "https://akjajay9315.github.io/tindog-bootstrap-design/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "A Weather App",
          description:
            "This app uses a weather API to check the weather and temperature by entering a city name. The graphical background changes according to the weather.",
          animationDelay: "730",
          buttonLink: "https://akjajay9315.github.io/DEMO-weather-app/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Dhol-key",
          description:
            "Dhol-key is a game for children to play instruments via keys or mouse, made using JavaScript.",
          animationDelay: "780",
          buttonLink: "https://akjajay9315.github.io/Dhol-Key/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Under Construction",
          description: "</>",
          animationDelay: "830",
          buttonText: "",
        },
      ],
    },
    internships: {
      internship: [
         {
      companyName: "SCRAPUNCLE (Onsite)",
      role: "Backend Developer - SDE",
      // introText:
      //   "Contributed to backend development using Golang, Node.js, and TypeScript, focusing on system optimization, communication services, and secure payment handling.",
      duration: "August ’24 - Present",
      keyPointOne:
        "Contributed to a unified backend repository built with Golang (Gin), optimizing its structure and resolving issues in Pickup-Routes handling and event-driven workflows to improve performance.",
      keyPointTwo:
        "Re-architected the communication service for modularity and integrated APIs including MSG91 and Meta via Node.js and TypeScript, enhancing automation and message reliability.",
      keyPointThree:
        "Maintained the payment service by fixing webhook and connection issues, integrating Zoho for invoice and vendor handling, and utilizing AWS Lambda, S3, and Prisma ORM for scalable event-driven debugging and data consistency.",
      offsetValue: "0",
    },
        {
      companyName: "PORTER (Bengaluru Head Office)",
      role: "Backend Developer - SDE Intern",
      // introText:
      //   "Integrated Checkout-Vendor flow for 20,000+ UAE users using clean code, DDD, and Hexagonal Architecture; improved observability and reliability across multiple Ktor microservices.",
      duration: "April ’25 – August ’25",
      keyPointOne:
        "Integrated Checkout-Vendor flow for 20,000+ UAE users using DDD and Hexagonal Architecture; added audit tables in Ktor microservices deployed on Kubernetes for enhanced traceability.",
      keyPointTwo:
        "Refactored the Partner App Gateway, optimizing 5+ service flows and ensuring API correctness using Flash deep links, Chucker, Postman, and DBeaver.",
      keyPointThree:
        "Managed 10+ deployments and 6+ inter-service repositories using ArgoCD for GitOps-based delivery, maintaining 99.9% uptime and improving observability via Grafana and Datadog.",
      keyPointFour:
        "Resolved 10+ production issues by tracing Ktor client-server flows, addressing refund delays and versioning mismatches; boosted test coverage to 90% through targeted unit testing.",
      offsetValue: "-1000",
    },
        {
          companyName: "LINUX MANTRA IT SERVICES PVT. LTD.",
          role: "Web Developer Intern",
          // introText:
          //   "Constructed web applications across 5+ sectors, including travel, EV, AWS, air ticketing, and hotel booking, providing advanced digital solutions for key clients including Gilpin Travel, Yatra, and Glida.",
          duration: "May ’24 - July ’24",
          keyPointOne:
            "Introduced 5+ features and crafted responsive user interfaces using ReactJS, AngularJS, TypeScript, and JavaScript, achieving a 25% reduction in page load times and improved API performance.",
          keyPointTwo:
            "Deployed 4+ filtering and search functionalities for Gilpin Travel and Yatra, enhancing booking accuracy and optimizing interactions for 2000+ end-users.",
          keyPointThree:
            "Collaborated with cross-functional teams to enhance the overall user experience and optimize application performance.",
          keyPointFour:
            "Contributed to the testing and debugging processes, ensuring the reliability and stability of the applications before deployment.",
          offsetValue: "-1000",
        },

        // {
        //   companyName: "Company Name",
        //   role: "Front-end Developer",
        //   introText: "",
        //   duration: "14/06/2021 - 14/07/2021",
        //   keyPointOne: "Built front-end of multiple websites using ReactJS.",
        //   keyPointTwo: "Add few lines here... if required",
        //   keyPointThree: "Add few lines here... if required",
        //   keyPointFour:
        //     "Add few lines here... if required. Lorem, ipsum dolor sit amet consectetur adipisicing cto molestiae.",
        //   offsetValue: "-1000",
        // },
        // {
        //   companyName: "Company Name",
        //   role: "Front-end Developer",
        //   introText: "",
        //   duration: "10/09/2020 - 10/11/2020",
        //   keyPointOne: "Add few lines here... if required",
        //   keyPointTwo: "Add few lines here... if required",
        //   keyPointThree: "Add few lines here... if required",
        //   keyPointFour: "",
        //   offsetValue: "-1000",
        // },
      ],
    },
  },
};

export default config;
